// 表单描述
export const FormDesc =  [
  {
    label: '默认值',
    prop: "defaultValue",
    children: {
      tags: "el-input",
      attrs: {
        placeholder: '请输入默认值'
      }
    },
  },
  {
    label: '验证表达式',
    prop: "validateExpression",
    tooltip: "示例：/^[0-9]{8}$/ 8位数字",
    children: {
      tags: "el-input",
      attrs: {
        placeholder: '请输入默认值'
      }
    },
  },
  {
    label: '存储为label',
    prop: "isLabelValue",
    tooltip: "示例：/^[0-9]{8}$/ 8位数字",
    children: {
      tags: "el-input",
      attrs: {
        placeholder: '请输入默认值'
      }
    },
  },
]


/**
 * 下拉元素Table列配置
 * @type {[{label: string, type: string, align: string},{children: {tags: string, attrs: {placeholder: string}}, prop: string, label: string, align: string},{children: {tags: string, attrs: {placeholder: string}}, prop: string, label: string, align: string},{children: {tags: string, attrs: {placeholder: string}}, prop: string, label: string, align: string},{children: {tags: string, attrs: {placeholder: string}}, prop: string, label: string, align: string}]}
 */
export const TableEditorColumns = [
  {
    label: "#",
    type: "index",
    align: "center"
  },
  {
    label: "Label",
    prop: "label",
    align: "center",
    children: {
      tags: "ed-input-pop",
      attrs: {
        placeholder: "Label"
      }
    }
  },
  {
    label: "Value",
    prop: "value",
    align: "center",
    children: {
      tags: "ed-input-pop",
      attrs: {
        placeholder: "Value"
      }
    }
  },
  {
    label: "触发控件",
    prop: "triggerControl",
    align: "center",
    children: {
      tags: "ed-input-pop",
      attrs: {
        placeholder: "触发控件"
      }
    }
  },
  {
    label: "默认选中",
    prop: "isChecked",
    align: "center",
    children: {
      tags: "el-switch",
      attrs: {
        placeholder: "默认选中"
      }
    }
  }
]

export const  TableEditorRules = {
  label: [
    {required: true, message: '必填', trigger: 'blur'}
  ],

  value: [
    {required: true, message: '必填', trigger: 'blur'}
  ]
}

